
import SEO from "../seo";
import { useEffect, useState } from "react";
import { getGoodsList } from "../../../utils/func";
import GoodsGridList from "../goods/gridList";
import GoodsHorizontalList from "../goods/horizontalList";

function ShopProductsPage({
    siteName,
    pageTitle
}) {
    const [goodsList,setGoodsList] = useState([])
    useEffect(() => {
        getGoodsList().then(result => {
            
            setGoodsList(result)
        }).catch(err => {

        })
    },[])

    return (
        <>
            <SEO 
                siteName={siteName}
                pageTitle={pageTitle}
            />
            {/* Our Product */}
            <div className="section-full p-t80">
                <div className="container">
                    <div className="section-content">
                        {/* TITLE START */}
                        <div className="section-head text-center">
                            <h2 data-title="Products">Our Products</h2>
                            <div className="mt-separator-outer m-b30">
                                <div className="mt-separator site-bg-primary" />
                            </div>
                        </div>
                        
                        <GoodsGridList 
                            is_need_fetch={false}
                            list={goodsList}
                        />
                        
                    </div>
                </div>
            </div>
            {/* Featured products */}
            <div className="section-full p-t80 p-b50">
                <div className="container">
                    <div className="section-content">
                        {/* TITLE START */}
                        <div className="section-head text-center">
                            <h2 data-title="Featured">Featured Products</h2>
                            <div className="mt-separator-outer  m-b30">
                                <div className="mt-separator site-bg-primary" />
                            </div>
                        </div>
                        {/* TITLE END */}
                        <GoodsHorizontalList
                            list={goodsList.slice(0, 4)}
                        />
                        
                    </div>
                </div>
            </div>
        </>
    )
}
export default ShopProductsPage;